import { Component, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import swal from "sweetalert2";
import { ConnectService } from '@app/shared/services/connect.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-schedule-call-profile-details',
  templateUrl: './schedule-call-profile-details.component.html',
  styleUrls: ['./schedule-call-profile-details.component.css']
})
export class ScheduleCallProfileDetailsComponent implements OnInit {

  @ViewChild('SheduleProfileSnapshotModal') public SheduleProfileSnapshotModal: ModalDirective;
  @Output() refreshSnapShotAPI: EventEmitter<any> = new EventEmitter();
  connectionDetails: any = {};
  status: string = '';
  isAnalyst: boolean = false;
  userRole: string;
  loggedInUser: string;
  load: boolean;
  constructor(private router: Router, private connectService: ConnectService, private authenticationService: AuthenticationService) { }

  ngOnInit() {
    if (window.sessionStorage.getItem('userDetails')) {
      this.loggedInUser = JSON.parse(window.sessionStorage.getItem('userDetails')).id;
    }
    this.getRole();
  }
  showModal(connection) {
    this.load = true;
    this.connectionDetails = connection;
    this.isAnalyst = false;
    this.status = status;
    this.SheduleProfileSnapshotModal.show();
  }
  hideModal() {
    this.refreshSnapShotAPI.emit();
    this.SheduleProfileSnapshotModal.hide();
  }
  refreshAPI() {
    this.hideModal();
  }
  viweMessagePage(id) {
    localStorage.setItem('userIDFromNxtPage', id);
    this.connectService.createGroup(id).subscribe(
      (resp: any) => {
        const userType = this.authenticationService.getLoggedUserType();
        this.router.navigate([`${userType}/messages`]);
        this.hideModal();
      },
      (error) => {

      }
    )
  }

  createGroup(id) {
    localStorage.setItem('userIDFromNxtPage', id);
    this.connectService.createGroup(id).subscribe(
      (resp: any) => {
        this.router.navigate([`${this.userRole}/messages`]);
      },
      (error) => {
        swal("Info", error.error.error.message, "info");
      }
    )
  }
  patchChangeConnectionSatus(id, status) {
    this.connectService.updateConnectionStatus(id, status).subscribe(
      (data: any) => {
        swal("Success", data, "success");
        this.hideModal();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      });
  }

  viewProfile() {
    const userType = this.authenticationService.getLoggedUserType();
    this.router.navigate([`analyst-profile`], { queryParams: { analystId: this.connectionDetails.connectedUser.id } });
    this.hideModal();

  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-call-profile-details/schedule-call-profile-details.component.ts